import { useEffect } from 'react'
import { getLanguage, setLanguage } from '@/i18n'
import { preferencesStore } from '../services/preferencesStore'

/**
 * Preferences.language ↔ i18n の同期 (Track D, 多端末同期)。
 *
 * 動作:
 *   - preferencesStore.subscribe で `language` の変更を検出 → i18n.setLanguage に反映
 *   - これにより ookey-ios / ookey-browser で言語を切り替えた値が web にも伝播する
 *     (ログイン直後 / preferences refresh タイミングで pickup)
 *
 * useTheme と同じく App.tsx ルート級で 1 回だけ呼ぶ前提。
 *
 * 書き込み方向 (web で変更 → server): SettingsPage が updatePreference('language', ...) で
 * 直接行う。本 hook は読み取り (server → i18n) のみを担当する。
 */
export const useLanguageSync = (): void => {
  useEffect(() => {
    return preferencesStore.subscribe(prefs => {
      if (prefs.language && prefs.language !== getLanguage()) {
        setLanguage(prefs.language)
      }
    })
  }, [])
}
